import { APP_ENV } from '@/shared/config/env';

import * as httpApi from './customers-api-http';
import * as mockApi from './customers-api-mock';

const useLive = APP_ENV.bizApiMode === 'live';

export type UpdateCustomerNotesPayload = httpApi.UpdateCustomerNotesPayload;
export type CreateCustomerPayload = httpApi.CreateCustomerPayload;
export type CreatePetPayload = httpApi.CreatePetPayload;

export async function listCustomerSummaries() {
  return useLive ? httpApi.listCustomerSummaries() : mockApi.listCustomerSummaries();
}

export async function getCustomerProfile(customerId: string) {
  return useLive ? httpApi.getCustomerProfile(customerId) : mockApi.getCustomerProfile(customerId);
}

export async function updateCustomerNotes(payload: UpdateCustomerNotesPayload) {
  return useLive ? httpApi.updateCustomerNotes(payload) : mockApi.updateCustomerNotes(payload);
}

export async function createCustomer(payload: CreateCustomerPayload) {
  return httpApi.createCustomer(payload);
}

export async function findDuplicateCustomerByPhone(phone: string) {
  return httpApi.findDuplicateCustomerByPhone(phone);
}

export async function listPets(customerId?: string) {
  return httpApi.listPets(customerId);
}

export async function createPet(payload: CreatePetPayload) {
  return httpApi.createPet(payload);
}
